import { Component, ElementRef, HostBinding, OnInit, ViewChild } from '@angular/core';
import { NavigationExtras, Router } from '@angular/router';
import { BreakpointObserver, Breakpoints, BreakpointState } from '@angular/cdk/layout';
import { AuthService, ScreenService, AppInfoService } from './shared/services';
import { AlertifyService } from './shared/services/alertify.service';
import { LoaderService } from './shared/services/loader.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { MatSidenav } from '@angular/material/sidenav';
import { AuthUserService } from './shared/services/AuthUser.service';

declare const require: any; // 版本資訊

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  providers: [ AuthUserService ]
})
export class AppComponent implements OnInit {

  // ViewChild用法參考 https://stackoverflow.com/questions/70801522/viewchild-initializer-error-on-angular-13
  @ViewChild('drawer') drawer: MatSidenav = {} as MatSidenav;
  
  public version: string = require('../../package.json').version; // 版本資訊;
  // version: string = '1.1.0';
  opened!: boolean;
  isLoadingResults = false;
  searchActive = false;
  notifyActive = false;
  homeActive = false;
  syncActive = false;
  checkInActive = false;
  title: string = '滿意度問卷';
  userName!: string;

  isHandset$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.Handset)
  .pipe(
    map(result => result.matches)
  );
  
  constructor(private breakpointObserver: BreakpointObserver,
    private router: Router,
    private loaderService: LoaderService,
    public authService: AuthService,
    private authUsersService: AuthUserService,
    private alertify: AlertifyService) {
    // this.router.navigate(['login']);
  }

  ngOnInit() {
    this.loaderService.loaderStatus.subscribe(result => {
      this.isLoadingResults = result;
    });
    this.opened = false;
    this.getUsername();
  }

  isAuthenticated() {
    return this.authService.loggedIn;
  }

  logout() {
    this.authService.logout();
    console.log('logoutok');
    this.router.navigate(['/survey01/not-exist']);
  }

  getUsername() {
    const decodedToken = this.authUsersService.getDecodedToken();
    // console.log('decodedToken', decodedToken);
    if (decodedToken !== null) {
      this.userName = decodedToken.UserName;
    } else {
      this.userName = ''; // 2022-05-22 依Q99將其改為空白'登入者';
    }
    return ''; // decodedToken.unique_name;
  }

  isShowTopBar() {
    const pathArray = this.router.url.split("/");
    return !pathArray.some((element: string) => element.match(/^survey\d+$/));
  }
  
}
